import React from "react";
import { Input, Form } from "antd";
const { TextArea } = Input;

const UiTextArea = (props) => {
  const FormItem = Form.Item;

  const {
    title,
    name,
    bordered,
    value,
    style,
    placeholder,
    maxLength,
    showCount,
    onChange,
    validation,
  } = props;
  return (
    <FormItem name={name} label={title} rules={validation}>
      {/* {title.length>0? <div>
      <label>{title}</label>
      </div>:""} */}
      <TextArea
        rows={4}
        style={style}
        value={value}
        title={title}
        maxLength={maxLength}
        showCount={showCount}
        bordered={bordered ?? true}
        name={name}
        placeholder={placeholder}
        onChange={onChange}
      />
    </FormItem>
  );
};

export default UiTextArea;
